import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {CaptureDetail} from "./capture-detail";

const CaptureDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/captures');
    }

    return (
        <CaptureDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default CaptureDetailPage;
